(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("knockout"));
	else if(typeof define === 'function' && define.amd)
		define("Table4JS", ["knockout"], factory);
	else if(typeof exports === 'object')
		exports["Table4JS"] = factory(require("knockout"));
	else
		root["Table4JS"] = factory(root["ko"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_knockout__) => {
return 